module.exports = __webpack_public_path__ + "img/s3.67d2e213.png";